import InfoIcon from './InfoIcon.jsx';
import './PersonCard.css';

function telHref(phone) {
  return `tel:+1${phone.replace(/\D/g, '')}`;
}

export default function PersonCard({ person }) {
  const {
    name,
    title,
    email,
    phone,
    responsibility,
    source,
    sources,
    verificationNeeded,
  } = person;

  return (
    <div className={`person-card${verificationNeeded ? ' person-card--caution' : ''}`}>
      {verificationNeeded && (
        <span className="person-card-verify-badge">Verify at orientation</span>
      )}

      <div className="person-card-header">
        <div className="person-card-info">
          <h3 className="person-card-name">{name}</h3>
          <p className="person-card-title">{title}</p>
        </div>
        <InfoIcon source={source} sources={sources} />
      </div>

      {responsibility && (
        <p className="person-card-responsibility">{responsibility}</p>
      )}

      {(email || phone) && (
        <div className="person-card-contacts">
          {email && (
            <a href={`mailto:${email}`} className="person-card-contact-link">
              {email}
            </a>
          )}
          {phone && (
            <a href={telHref(phone)} className="person-card-contact-link">
              {phone}
            </a>
          )}
        </div>
      )}
    </div>
  );
}
